import { Component, OnInit } from '@angular/core';
import { HazardsService } from './hazards.service';
import { CapabilityEngineService } from '../capabilityEngine.service';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { RedirectService } from '../redirect/redirect.service';

@Component({
    selector: 'app-hazards',
    templateUrl: './hazards.component.html',
    styleUrls: ['./hazards.component.scss']
})
export class HazardsComponent implements OnInit {

    hazardFormTemplate: any = {};
    sortKey: String;
    sortOrder: String;

    constructor(
        private _hazardsService: HazardsService,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute

    ) { }


    ngOnInit() {
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this._hazardsService.getHazards()
                .subscribe((result: any) => {
                    this.hazardFormTemplate = result.data;
                });
        }
    }

    sort(key) {
        if (key === this.sortKey) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    downloadRawData() {
        this._hazardsService.getRawData();
    }

}



// WEBPACK FOOTER //
// ./src/app/hazards/hazards.component.ts